module.exports = "/lucky-balls/img/bigball/BigBall_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_011.png
// module id = 906
// module chunks = 0